import { Button, CardBackground, Typography } from "@hellocarbo/lasagne";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router";

import carbonCalculatorImage from "@/assets/fr/carbonCalculator.png";

import AdditionalModules from "./AdditionalModules";

function EmptyView() {
  const { t } = useTranslation("simulation");

  return (
    <div className="gap-y-md flex flex-col">
      <CardBackground>
        <div className="gap-x-lg gap-y-sm mb-lg flex flex-col xl:grid xl:grid-cols-2">
          <div>
            <Typography as="h2" step="1" weight="bold" className="mb-xs">
              {t("simulation:emptyView.title")}
            </Typography>

            <Typography className="mb-2xs">
              <Trans
                t={t}
                i18nKey="simulation:emptyView.text1"
                components={{ 1: <span className="font-bold" /> }}
              />
            </Typography>
            <Typography>
              <Trans
                t={t}
                i18nKey="simulation:emptyView.text2"
                components={{ 1: <span className="font-bold" /> }}
              />
            </Typography>
          </div>
          <img
            src={carbonCalculatorImage}
            className="my-sm order-first xl:order-last"
            alt={t("simulation:emptyView.imageAlt")}
          />
        </div>
        <div className="flex justify-center">
          <Button as={Link} to="/simulations/scenarios">
            {t("simulation:emptyView.cta")}
          </Button>
        </div>
      </CardBackground>
      <AdditionalModules />
    </div>
  );
}
export default EmptyView;
